import { CHANNEL_MODE, CLIENT_CONTEXT, RESET, UPDATE_ANALYTICS, UPDATE_APPDATA, UPDATE_AUTHENTICATIONSTATE, UPDATE_CONFIG, UPDATE_DONTSEENUMBER, UPDATE_ERRORCONATINER, UPDATE_ERRORMESSAGE, UPDATE_FLOW, UPDATE_HASANALYTICS, UPDATE_ISAUTHENTICATE, UPDATE_ISCANCELAUTHENTICATIONENABLED, UPDATE_ISDIDNOTRECEIVECODE, UPDATE_ISDISCLOSUREVISIBLE, UPDATE_ISSENDCODEASVOICEENABLED, UPDATE_IS_LOADING, UPDATE_LANGUAGECODE, UPDATE_OPTEDOUT, UPDATE_OTPATTEMPTS, UPDATE_OTPCODEVALUE, UPDATE_OTP_ACTION, UPDATE_PARAMS, UPDATE_PAYLOAD, UPDATE_PHONENUMBER, UPDATE_PHONESECURITYRESPONSE, UPDATE_POSSIBLETARGETS, UPDATE_REQUIREDERRORMSG, UPDATE_RETRY, UPDATE_RETRY_CONTAINER, UPDATE_SELECTEDTARGET, UPDATE_SENDOTP, UPDATE_SFFDL, UPDATE_SMSCHANNEL, UPDATE_TARGETS, UPDATE_VERIFYCLICKED, UPDATE_VERIFYOTPSCREEN, UPDATE_VOICECHANNEL, RESET_OTP_ACTION, UPDATE_SEND_CODE_AS } from '../constants/action-types';
export function resetOtpAction() {
    return {
        type: RESET_OTP_ACTION
    };
}
export function updateSendCodeAs(payload) {
    return {
        type: UPDATE_SEND_CODE_AS,
        payload: payload
    };
}
export function updateOtpAction(payload) {
    return {
        type: UPDATE_OTP_ACTION,
        payload: payload
    };
}
export function updatePayload(payload) {
    return {
        type: UPDATE_PAYLOAD,
        payload: payload
    };
}
export function updateOtpCode(payload) {
    return {
        type: UPDATE_OTPCODEVALUE,
        payload: payload
    };
}
export function updateCancelAuthenticator(payload) {
    return {
        type: UPDATE_ISCANCELAUTHENTICATIONENABLED,
        payload: payload
    };
}
export function updateChannelMode(payload) {
    return {
        type: CHANNEL_MODE,
        payload: payload
    };
}
export function updateRetryAuthenticator(payload) {
    return {
        type: UPDATE_RETRY,
        payload: payload
    };
}
export function updateRetryContainer(payload) {
    return {
        type: UPDATE_RETRY_CONTAINER,
        payload: payload
    };
}
export function updateFlow(payload) {
    return {
        type: UPDATE_FLOW,
        payload: payload
    };
}
export function updateClientContext(payload) {
    return {
        type: CLIENT_CONTEXT,
        payload: payload
    };
}
export function updateDontSeeNumber(payload) {
    return {
        type: UPDATE_DONTSEENUMBER,
        payload: payload
    };
}
export function updateisDidNotReceiveCode(payload) {
    return {
        type: UPDATE_ISDIDNOTRECEIVECODE,
        payload: payload
    };
}
export function updateSmsChannel(payload) {
    return {
        type: UPDATE_SMSCHANNEL,
        payload: payload
    };
}
export function updateVoiceChannel(payload) {
    return {
        type: UPDATE_VOICECHANNEL,
        payload: payload
    };
}
export function updateVerifyOtpScreen(payload) {
    return {
        type: UPDATE_VERIFYOTPSCREEN,
        payload: payload
    };
}
export function updatePossibleTargets(payload) {
    return {
        type: UPDATE_POSSIBLETARGETS,
        payload: payload
    };
}
export function updateIsDisclosureVisible(payload) {
    return {
        type: UPDATE_ISDISCLOSUREVISIBLE,
        payload: payload
    };
}
export function updateIsEncodAsVoiceEnabled(payload) {
    return {
        type: UPDATE_ISSENDCODEASVOICEENABLED,
        payload: payload
    };
}
export function updateAuthenticationState(payload) {
    return {
        type: UPDATE_AUTHENTICATIONSTATE,
        payload: payload
    };
}
export function updatePhoneSecurityResponse(payload) {
    return {
        type: UPDATE_PHONESECURITYRESPONSE,
        payload: payload
    };
}
export function updateTargets(payload) {
    return {
        type: UPDATE_TARGETS,
        payload: payload
    };
}
export function updateIsAuthenticate(payload) {
    return {
        type: UPDATE_ISAUTHENTICATE,
        payload: payload
    };
}
export function updateSendOtp(payload) {
    return {
        type: UPDATE_SENDOTP,
        payload: payload
    };
}
export function updateErrorContainer(payload) {
    return {
        type: UPDATE_ERRORCONATINER,
        payload: payload
    };
}
export function updateErrorMessage(payload) {
    return {
        type: UPDATE_ERRORMESSAGE,
        payload: payload
    };
}
export function updateVerifyOtp(payload) {
    return {
        type: UPDATE_VERIFYCLICKED,
        payload: payload
    };
}
export function updateOptedOut(payload) {
    return {
        type: UPDATE_OPTEDOUT,
        payload: payload
    };
}
export function updateLanguageCode(payload) {
    return {
        type: UPDATE_LANGUAGECODE,
        payload: payload
    };
}
export function updatePhoneNumber(payload) {
    return {
        type: UPDATE_PHONENUMBER,
        payload: payload
    };
}
export function updateSelectedTarget(payload) {
    return {
        type: UPDATE_SELECTEDTARGET,
        payload: payload
    };
}
export function updateOtpAttempts(payload) {
    return {
        type: UPDATE_OTPATTEMPTS,
        payload: payload
    };
}
export function updateConfig(payload) {
    return {
        type: UPDATE_CONFIG,
        payload: payload
    };
}
export function updateSFFDL(payload) {
    return {
        type: UPDATE_SFFDL,
        payload: payload
    };
}
export function updateAnalytics(payload) {
    return {
        type: UPDATE_ANALYTICS,
        payload: payload
    };
}
export function updateHasAnalytics(payload) {
    return {
        type: UPDATE_HASANALYTICS,
        payload: payload
    };
}
export function updateParams(payload) {
    return {
        type: UPDATE_PARAMS,
        payload: payload
    };
}
export function Reset() {
    return {
        type: RESET
    };
}
export function updateAppData(payload) {
    return {
        type: UPDATE_APPDATA,
        payload: payload
    };
}
export function updateRequiredErrorMsg(payload) {
    return {
        type: UPDATE_REQUIREDERRORMSG,
        payload: payload
    };
}
export function updateIsLoading(payload) {
    return {
        type: UPDATE_IS_LOADING,
        payload: payload
    };
}
